import React, { useEffect, useState } from "react";

// Click-to-rename text. Saves via onSave(newValue) on blur/Enter; Escape reverts.
export default function EditableTitle({
  value,
  onSave,
  className = "",
  style = {},
  inputStyle = {},
  placeholder = "",
}) {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(value || "");

  useEffect(() => {
    if (!editing) setDraft(value || "");
  }, [value, editing]);

  const commit = () => {
    setEditing(false);
    const trimmed = draft.trim();
    if (trimmed && trimmed !== value) onSave(trimmed);
    else setDraft(value || "");
  };

  if (editing) {
    return (
      <input
        autoFocus
        className={className}
        style={{ ...style, ...inputStyle }}
        value={draft}
        onChange={(e) => setDraft(e.target.value)}
        onBlur={commit}
        onClick={(e) => e.stopPropagation()}
        onKeyDown={(e) => {
          if (e.key === "Enter") commit();
          if (e.key === "Escape") {
            setDraft(value || "");
            setEditing(false);
          }
        }}
      />
    );
  }

  return (
    <span
      className={className}
      style={{ cursor: "text", ...style }}
      title="Click to rename"
      onClick={(e) => {
        e.stopPropagation();
        setEditing(true);
      }}
    >
      {value || placeholder}
    </span>
  );
}
